import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./EmptyState.module.css";
/**
 * Estado vazio do Azim CRM.
 * Use para listas sem resultado, filtros sem match, etc.
 */
export function EmptyState({ icon = "inbox", title, body, action }) {
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("div", { className: styles.icon, "aria-hidden": "true", children: _jsx(Icon, { name: icon, size: 24 }) }), _jsx("div", { className: styles.title, children: title }), body && _jsx("div", { className: styles.body, children: body }), action && _jsx("div", { className: styles.action, children: action })] }));
}
//# sourceMappingURL=EmptyState.js.map